import { cn } from "@/lib/utils";

import logoRuinart from "@/assets/logos/ruinart.png?format=webp";
import logoTinder from "@/assets/logos/tinder.png?format=webp";
import logoBumble from "@/assets/logos/bumble.png?format=webp";
import logoAsahi from "@/assets/logos/asahi.png?format=webp";
import logoGuardianGlass from "@/assets/logos/guardian-glass.png?format=webp";
import logoUber from "@/assets/logos/uber.png?format=webp";
import logoPeroni from "@/assets/logos/peroni.png?format=webp";
import logoLeuchtturm from "@/assets/logos/leuchtturm.png?format=webp";
import logoAtlanticAirways from "@/assets/logos/atlantic-airways.png?format=webp";
import logoSato from "@/assets/logos/sato.png?format=webp";
import logoVoyagePrive from "@/assets/logos/voyage-prive.png?format=webp";
import logoBroilKing from "@/assets/logos/broil-king.png?format=webp";
import logoRia from "@/assets/logos/ria.png?format=webp";

interface LogoMarqueeProps {
  className?: string;
}

const logos = [
  { id: 1, name: "Ruinart", src: logoRuinart },
  { id: 2, name: "Tinder", src: logoTinder },
  { id: 3, name: "Bumble", src: logoBumble },
  { id: 4, name: "Asahi", src: logoAsahi },
  { id: 5, name: "Guardian Glass", src: logoGuardianGlass },
  { id: 6, name: "Uber", src: logoUber },
  { id: 7, name: "Peroni", src: logoPeroni },
  { id: 8, name: "Leuchtturm1917", src: logoLeuchtturm },
  { id: 9, name: "Atlantic Airways", src: logoAtlanticAirways },
  { id: 10, name: "Sato", src: logoSato },
  { id: 11, name: "Voyage Privé", src: logoVoyagePrive },
  { id: 12, name: "Broil King", src: logoBroilKing },
  { id: 13, name: "Ria Money Transfer", src: logoRia },
];

export function LogoMarquee({ className }: LogoMarqueeProps) {
  return (
    <div className={cn("relative overflow-hidden py-4", className)}>
      {/* Title */}
      <div className="text-center mb-8 md:mb-12">
        <h3 className="font-serif text-heading-lg text-foreground">
          Brands who put trust in The Zoom Agency
        </h3>
      </div>

      {/* Mobile: Static grid - 3x4, excluding Broil King for even 12 */}
      <div className="md:hidden grid grid-cols-3 gap-4 px-2">
        {logos
          .filter((logo) => logo.name !== "Broil King")
          .map((logo) => (
            <div
              key={logo.id}
              className="flex items-center justify-center p-2"
            >
              <img
                src={logo.src}
                alt={logo.name}
                className="logo-adaptive h-6 w-auto object-contain opacity-70"
              />
            </div>
          ))}
      </div>

      {/* Desktop: Marquee container */}
      <div className="hidden md:block relative overflow-hidden">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-background to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-background to-transparent z-10" />

        {/* Scrolling track */}
        <div className="flex w-max animate-marquee">
          {/* First set of logos */}
          {logos.map((logo) => (
            <div
              key={logo.id}
              className="flex-shrink-0 px-10 flex items-center justify-center"
            >
              <img
                src={logo.src}
                alt={logo.name}
                className="logo-adaptive h-10 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
          {/* Duplicate set for seamless loop */}
          {logos.map((logo) => (
            <div
              key={`dup-${logo.id}`}
              className="flex-shrink-0 px-10 flex items-center justify-center"
            >
              <img
                src={logo.src}
                alt={logo.name}
                className="logo-adaptive h-10 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}